// import * as pdfjsLib from "pdfjs-dist";
// import "pdfjs-dist/web/pdf_viewer.css";
const pdfjsLib = require("pdfjs-dist");
require("pdfjs-dist/web/pdf_viewer.css")
pdfjsLib.GlobalWorkerOptions.workerSrc = `../../static/pdf.worker.min.js`
module.exports = san.defineComponent({
    template: require('../views/IntelligentGeneration/pdf.html'),
    initData: function () {
        return {
            
        }
    },
    components: {},
    created: function () {
    },
    attached: function(){
        var me=this;
    },
    getPdf:function(){
        const container = this.el.querySelector('#pdf-canvas')
        const url = 'https://shidu-legalrobot-bz.oss-cn-hangzhou.aliyuncs.com/jrhg/document/2025081114094036087/东方证券股份有限公司合规管理有效性评估实施办法（2025年修订）.pdf';
        pdfjsLib.getDocument(url).promise.then(pdf => {
        pdf.getPage(1).then(page => {
        const viewport = page.getViewport({ scale: 1.5 });
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        container.appendChild(canvas);
        
        page.render({ canvasContext: ctx, viewport });
      })
    })

    },
    messages: {}
});



//////////////////
// WEBPACK FOOTER
// ./src/components/pdf.js
// module id = 368
// module chunks = 1